import type {AiRedesignPromptBoxPanel} from '@Panels/ai-redesign-prompt-box-panel/ai-redesign-prompt-box-panel.types';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

export * from './ai-redesign-prompt-box-modal';

export const openAiRedesignPromptBoxModal = (props: AiRedesignPromptBoxPanel): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.AI_REDESIGN_PROMPT_BOX_MODAL,
      panelProps: props,
    })
  );
};
